var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"desc"},[_c('title-main',{attrs:{"align":_vm.isMobile ? 'center' : 'left'}},[_vm._t("title")],2),_c('h6',{staticClass:"use-text-subtitle2",class:[_vm.isMobile ? 'text-center' : 'text-left']},[_vm._t("text")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }